<app-navbar [title]="'Korespondencja'">
	<a routerLink="./add" class="btn btn-primary"> <i class="fas fa-plus"></i> Dodaj </a>
</app-navbar>

<div id="loader" *ngIf="loader"><span class="spinner-border spinner-grow-lg"></span></div>

<app-post-filters
	[userFilters]="'postIn'"
	[taskStatuses]="parameters.tasksStatuses"
	[senders]="senders"
	[users]="users"
	[companies]="companies"
	(selected)="filtersSelected($event)"
></app-post-filters>

<app-dynamic-table
	module="postIn"
	[elements]="posts"
	[tableRows]="tableRows"
	(filtersClicked)="filtersOpen()"
></app-dynamic-table>
